// extracted by mini-css-extract-plugin
export var contained = "PrintandShare-module--contained--2bd40";
export var container = "PrintandShare-module--container--58cc6";
export var printBtn = "PrintandShare-module--printBtn--d31a1";
export var printandshare = "PrintandShare-module--printandshare--e825c";